import React, { useEffect, useState } from 'react';
import { Users, UserCheck, UserRound, MessageSquare } from 'lucide-react';
import CountUp from 'react-countup';
import { DashboardService } from '../../services/dashboardService';
import { DashboardStats } from '../../types/student';

const Widgets = () => {
    const [stats, setStats] = useState<DashboardStats>({
        totalStudents: 0,
        activeStudents: 0,
        totalCoaches: 0,
        totalGroups: 0
    });
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const loadStats = async () => {
            try {
                setIsLoading(true);
                const dashboardStats = await DashboardService.getDashboardStats();
                setStats(dashboardStats);
            } catch (error) {
                console.error('Error loading dashboard stats:', error);
            } finally {
                setIsLoading(false);
            }
        };

        loadStats();
    }, []);

    const LoadingWidget = () => (
        <div className="flex items-center justify-center h-24">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
        </div>
    );

    return (
        <React.Fragment>
            <div className="order-1 md:col-span-6 lg:col-span-3 col-span-12 2xl:order-1 bg-green-100 dark:bg-green-500/20 card 2xl:col-span-3 group-data-[skin=bordered]:border-green-500/20 relative overflow-hidden">
                <div className="card-body">
                    <UserCheck className="absolute top-0 size-32 stroke-1 text-green-200/50 dark:text-green-500/20 ltr:-right-10 rtl:-left-10"></UserCheck>
                    <div className="flex items-center justify-center size-12 bg-green-500 rounded-md text-15 text-green-50">
                        <Users />
                    </div>
                    <h5 className="mt-5 mb-2">
                        {isLoading ? <LoadingWidget /> : <CountUp end={stats.activeStudents} className="counter-value" />}
                    </h5>
                    <p className="text-slate-500 dark:text-slate-200">Active Students</p>
                </div>
            </div>

            <div className="order-2 md:col-span-6 lg:col-span-3 col-span-12 2xl:order-1 bg-orange-100 dark:bg-orange-500/20 card 2xl:col-span-3 group-data-[skin=bordered]:border-orange-500/20 relative overflow-hidden">
                <div className="card-body">
                    <Users className="absolute top-0 size-32 stroke-1 text-orange-200/50 dark:text-orange-500/20 ltr:-right-10 rtl:-left-10"></Users>
                    <div className="flex items-center justify-center size-12 bg-orange-500 rounded-md text-15 text-orange-50">
                        <Users />
                    </div>
                    <h5 className="mt-5 mb-2">
                        {isLoading ? <LoadingWidget /> : <CountUp end={stats.totalStudents} className="counter-value" />}
                    </h5>
                    <p className="text-slate-500 dark:text-slate-200">Total Students</p>
                </div>
            </div>

            <div className="order-3 md:col-span-6 lg:col-span-3 col-span-12 2xl:order-1 bg-sky-100 dark:bg-sky-500/20 card 2xl:col-span-3 group-data-[skin=bordered]:border-sky-500/20 relative overflow-hidden">
                <div className="card-body">
                    <UserRound className="absolute top-0 size-32 stroke-1 text-sky-200/50 dark:text-sky-500/20 ltr:-right-10 rtl:-left-10"></UserRound>
                    <div className="flex items-center justify-center size-12 rounded-md bg-sky-500 text-15 text-sky-50">
                        <UserRound />
                    </div>
                    <h5 className="mt-5 mb-2">
                        {isLoading ? <LoadingWidget /> : <CountUp end={stats.totalCoaches} className="counter-value" />}
                    </h5>
                    <p className="text-slate-500 dark:text-slate-200">Total Coaches</p>
                </div>
            </div>

            <div className="order-4 md:col-span-6 lg:col-span-3 col-span-12 2xl:order-1 bg-purple-100 dark:bg-purple-500/20 card 2xl:col-span-3 group-data-[skin=bordered]:border-purple-500/20 relative overflow-hidden">
                <div className="card-body">
                    <MessageSquare className="absolute top-0 size-32 stroke-1 text-purple-200/50 dark:text-purple-500/20 ltr:-right-10 rtl:-left-10"></MessageSquare>
                    <div className="flex items-center justify-center size-12 bg-purple-500 rounded-md text-15 text-purple-50">
                        <MessageSquare />
                    </div>
                    <h5 className="mt-5 mb-2">
                        {isLoading ? <LoadingWidget /> : <CountUp end={stats.totalGroups} className="counter-value" />}
                    </h5>
                    <p className="text-slate-500 dark:text-slate-200">Total Groups</p>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Widgets;